import {
  Box,
  Button,
  Center,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { MdEmail, MdLock, MdPhone } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import trainee from "../../img/login_hero_image.png";
// import trainee from "../../img/trainee.svg";
import naptinlogo from "../../img/naptinlogo.png";
import { AuthCredentials, IUserResponse } from "../../models/auth.model";
import authService from "../../services/auth.service";
import Adminroutes from "../admin/routes";
import routes from "../routes";
import trainerRoutes from "../trainer/routes";

import trainee_icon from "../../img/graduation-university-ceremony-education-graduate-svgrepo-com.svg";
import trainer_icon from "../../img/icons8-training-50.png";
import Footer from "../../components/common/Footer";

const Login = () => {
  const toast = useToast();
  const roleRedirect = (role: string) => {
    if (role == "trainer") {
      navigate(trainerRoutes.Dashboard);
    } else if (role == "trainee") {
      navigate(routes.Dashboard);
    } else if (role == "admin") {
      navigate(Adminroutes.Dashboard);
    }
  };
  const navigate = useNavigate();
  const validate = (values: any) => {
    const errors: any = {};
    if (!values.email) {
      errors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = "Invalid email address";
    }

    if (!values.password) {
      errors.password = "Password is required";
    }
    return errors;
  };

  const formik = useFormik({
    initialValues: { email: "", password: "" },
    validate,
    onSubmit: async (values) => {
      const authData: AuthCredentials = {
        email: values.email,
        password: values.password,
      };
      try {
        const auth: IUserResponse = await authService.login(authData);
        if ((auth.status = '"success"')) {
          localStorage.setItem("user", JSON.stringify(auth.data.user));
          localStorage.setItem("tokenId", auth.data.token);
          roleRedirect(auth.data.dashboard);

          toast({
            title: "Login",
            description: "Login successful",
            status: "success",
          });
        } else {
          toast({
            title: "Login",
            description: `${auth.message}.Try again or create an account`,
            status: "error",
          });
        }

        //roleRedirect();
      } catch (error: any) {
        // formik.errors.email = error.data.error;
        toast({
          title: "Login",
          description: `${error.response.data.message}. Try again or create an account`,
          status: "error",
        });
      }
    },
  });

  return (
    <>
      <Box height={"auto"}>
        <Flex
          height="45px"
          bg="#FFFFFF"
          borderBottom="0.3px solid"
          borderColor="gray.200"
          direction="row"
          px={["12px", "14px"]}
          alignItems="center"
          justifyContent="space-between"
        >
          <Flex alignItems="center">
            <Box as="span">
              <Box color="#EC3337" fontWeight="600" fontSize="12px">
                <Link to={routes.LandingPage}>Main Page</Link>
              </Box>
            </Box>
          </Flex>
          <Flex
            alignItems="center"
            height="inherit"
            color="#616161"
            fontSize="12px"
            lineHeight="16px"
            display={{ lg: "flex", md: "flex", sm: "none", base: "none" }}
          >
            <HStack>
              <MdPhone />
              <Text>
                08060844971, 08033543304, 07067777559 [9:00AM - 5:00PM] |
              </Text>
            </HStack>
            <HStack ml={2}>
              <MdEmail />
              <Text>support@naptinportal.com</Text>
            </HStack>
          </Flex>
        </Flex>

        <Flex height="100vh">
          <Box
            display={["none", "none", "block", "block"]}
            width={["0%", "0%", "40%", "45%"]}
          >
            <Image objectFit="cover" height="100%" width="100%" src={trainee} />
          </Box>

          <Box mx="auto" className="resizable_div">
            <Box
              ml={["30px", "30px", "40px", "60px"]}
              mr={["30px", "30px", "20px", "0px"]}
              mt="30px"
              mb="15px"
            >
              <Image mb="100px" maxHeight="45px" src={naptinlogo} />
              <Text
                mb={6}
                fontSize={["20px", "20px", "24px", "24px"]}
                fontWeight="semibold"
                color="brand.2"
              >
                Login to your account
              </Text>

              <form onSubmit={formik.handleSubmit}>
                <FormControl
                  mb="27px"
                  isInvalid={
                    formik.errors.email && formik.touched.email ? true : false
                  }
                >
                  <FormLabel color="#757575" fontSize={15}>
                    Email Address{" "}
                    <Text as="span" color="red">
                      *
                    </Text>
                  </FormLabel>

                  <Input
                    width={["300px", "300px", "420px", "420px"]}
                    type="email"
                    id="email"
                    name="email"
                    placeholder="alex@gmail.com"
                    onChange={formik.handleChange}
                    fontSize={14}
                  />

                  <FormErrorMessage fontSize={12}>
                    {formik.errors.email}
                  </FormErrorMessage>
                </FormControl>

                <FormControl
                  mb="27px"
                  isInvalid={
                    formik.errors.password && formik.touched.password
                      ? true
                      : false
                  }
                >
                  <FormLabel color="brand.subtitle" fontSize={15}>
                    Password{" "}
                    <Text as="span" color="red">
                      *
                    </Text>
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement
                      color="brand.subtitle"
                      pointerEvents="none"
                      children={<MdLock />}
                    />
                    <Input
                      width={["100%", "100%", "420px", "420px"]}
                      type="password"
                      name="password"
                      id="password"
                      placeholder="Enter your password"
                      onChange={formik.handleChange}
                      fontSize={14}
                    />
                  </InputGroup>
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.password}
                  </FormErrorMessage>
                </FormControl>

                <Stack spacing="12px">
                  <Button
                    cursor="pointer"
                    w="100%"
                    bg="red"
                    color="white"
                    type="submit"
                    isLoading={formik.isSubmitting}
                    fontSize={14}
                  >
                    LOGIN
                  </Button>

                  {/* <Button
                  cursor="pointer"
                  w="100%"
                  bg="white"
                  color="black"
                  // type="submit"
                  // isLoading={formik.isSubmitting}
                  fontSize={14}
                  border="1px"
                  borderColor="gray.200"
                  boxShadow="base"
                  letterSpacing={1}
                >
                  <Image src={google} alt="google logo" pr={4} />
                  Login with Google
                </Button> */}
                </Stack>

                <Center mt={8}>
                  <Box mb={2} alignSelf="center" color="#EC3337" fontSize={14}>
                    <Link to={routes.ForgotPassword}>Forgot Password?</Link>
                  </Box>
                </Center>

                <Center>
                  <Box color="#EC3337">
                    <Text
                      color="#616161"
                      fontSize={14}
                      alignSelf="center"
                      textAlign="center"
                    >
                      <Text>Don't have an account?</Text>{" "}
                    </Text>
                    <Flex
                      flexDirection={{
                        lg: "row",
                        md: "row",
                        sm: "column",
                        base: "column",
                      }}
                      justifyContent="center"
                      gap={{
                        lg: "0.5rem",
                        md: "0.5rem",
                        sm: "0rem",
                        base: "0rem",
                      }}
                      height="1.4rem"
                      mt={{
                        lg: "0.4rem",
                        md: "0.4rem",
                        sm: "0.6rem",
                        base: "0.6rem",
                      }}
                    >
                      <HStack
                        color="brand.bodyText"
                        fontSize={14}
                        alignSelf="center"
                      >
                        <Link to={routes.trainerPreReg}>
                          Create Trainer Account
                        </Link>
                        <Image src={trainer_icon} width="18px" height="18px" />
                      </HStack>
                      <Divider orientation="vertical" height="100%" />
                      <HStack
                        color="brand.bodyText"
                        fontSize={14}
                        alignSelf="center"
                      >
                        <Link to={routes.PreRegistration}>
                          Create Trainee Account
                        </Link>
                        <Image src={trainee_icon} width="18px" height="18px" />
                      </HStack>
                    </Flex>
                  </Box>
                </Center>
              </form>
            </Box>
          </Box>
        </Flex>
        <Footer />
      </Box>
    </>
  );
};

export default Login;
